import type { GetDynamicSectionsResponse } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';

import type { DeepRequired, Optional } from './general';

export type Section = NonNullable<
  GetDynamicSectionsResponse['sections']
>[number];

export enum AppGroupType {
  UNKNOWN = 'UNKNOWN',
  COLLECTION = 'COLLECTION',
  PROMO = 'PROMO',
}

export type AppGroupSection = Optional<
  DeepRequired<NonNullable<Section['appGroup']>>,
  'rows' | 'tagId'
>;

export type CategoryCarouselSection = DeepRequired<
  NonNullable<Section['categoryCarousel']>
>;
